/* @ngInject */
const consultRun = (
  $transitions,
  settingMenu
) => {
  $transitions.onBefore({
    to: 'index.setting',
  }, (trans) => {
    const state = trans.router.stateService
    const dest = 'index.setting.' + settingMenu.radio.value
    return state.target(dest)
  })

  $transitions.onSuccess({
    entering: 'index.consult.*',
  }, (trans) => {

  })
}

export default consultRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/setting.run.js